/* global console, require, fetch, OfficeRuntime */
const Localbase = require("localbase").default;
const Moment = require("moment-mini");

// main request
async function track(tracking_number, courier_code) {
  if (!tracking_number.length || !courier_code.length) throw new Error("Invalid request parameter");
  try {
    const apiKey = await getItem("key");
    if (!apiKey) throw new Error("Please authenticate");

    const url = "https://api.globalpackagetracker.com/shipment/track";
    const body = {
      tracking_number,
      courier_code,
    };
    console.log(body);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        key: apiKey,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    console.log(data);
    if (data.status == 200 && data.shipment) {
      data.shipment.request_timestamp = Date.now();
      data.shipment.id = data.shipment.tracking_number + data.shipment.courier_code;
      //await db.collection("shipments").add(data.shipment, data.shipment.tracking_number + data.shipment.courier_code);
      return data.shipment;
    } else if (data.status == 200) {
      throw new Error("No shipment data returned");
    } else if (data.message) {
      throw new Error(data.message);
    } else {
      throw new Error("Unknown error while fetching");
    }
  } catch (error) {
    if (error.message === "Shipment already exists") throw new Error("Please refresh");
    throw error;
  }
}

/**
 * Get the delivery status of the package
 * @customfunction
 * @param {string} tracking_number Provide your tracking number
 * @param {string} courier_code Provide the courier code
 * @return {string} Current delivery status of your package
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getStatus(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    return shipment.delivery_status;
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get current location and delivery status
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getCompleteStatus(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    return shipment.delivery_status + " at " + shipment.travel_history[0].location || "-";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get current location of the package
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @helpurl https://globalpackagetracker.com/pages/contact
 * @return {string}
 */
export async function getCurrentLocation(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    return shipment.travel_history[0].location || "-";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get all the locations the package has traveled from first until last event
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getTraveledLocations(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    const locations = [];
    shipment.travel_history.forEach((event) => {
      if (!event.location) return;
      locations.push(event.location);
    });
    const uniqueLocations = [...new Set(locations)];
    if (!uniqueLocations.length) return "No travel locations found";
    return uniqueLocations.reverse().join(" -> ");
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get date from first event
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getShippingDate(tracking_number, courier_code) {
  try {
    var dateFormat = await getItem("date_format");
    if (!dateFormat) dateFormat = "YYYY-MM-DD";
    const shipment = await track(tracking_number, courier_code);
    if (shipment.shipping_date !== null) {
      const date = new Date(shipment.shipping_date);
      return Moment(date).format(dateFormat);
    }
    return "Shipping date not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get label creation date
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getCreationDate(tracking_number, courier_code) {
  try {
    var dateFormat = await getItem("date_format");
    if (!dateFormat) dateFormat = "YYYY-MM-DD";
    const shipment = await track(tracking_number, courier_code);
    if (shipment.label_created_date !== null) {
      const date = new Date(shipment.label_created_date);
      return Moment(date).format(dateFormat);
    }
    return "Labael creation date not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get tracking registration date
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getRegistrationDate(tracking_number, courier_code) {
  try {
    var dateFormat = await getItem("date_format");
    if (!dateFormat) dateFormat = "YYYY-MM-DD";
    const shipment = await track(tracking_number, courier_code);
    if (shipment.createdAt !== null) {
      const date = new Date(shipment.createdAt);
      return Moment(date).format(dateFormat);
    }
    return "Labael creation date not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get delivery date
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getDeliveryDate(tracking_number, courier_code) {
  try {
    var dateFormat = await getItem("date_format");
    if (!dateFormat) dateFormat = "YYYY-MM-DD";
    const shipment = await track(tracking_number, courier_code);
    if (shipment.delivery_date !== null) {
      const date = new Date(shipment.delivery_date);
      return Moment(date).format(dateFormat);
    }
    return "Delivery date not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get origin of the package
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getOrigin(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.origin !== null) return shipment.origin;
    return "Shipment origin not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get destination of the package
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getDestination(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.destination !== null) return shipment.destination;
    return "Shipment destination not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get days passed from first until latest event
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getTransitTime(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.transit_time !== null) return shipment.transit_time;
    return "Transit time not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get costs
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getCosts(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.costs !== null) return shipment.costs;
    return "Shipment costs not provided yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get service type
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getServiceType(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.service_type !== null) return shipment.service_type;
    return "Unknown service type";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get latest event
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getLatestEvent(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.latest_event !== null) return shipment.latest_event;
    return "Latest event not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get latest event date
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getLatestEventDate(tracking_number, courier_code) {
  try {
    var dateFormat = await getItem("date_format");
    if (!dateFormat) dateFormat = "YYYY-MM-DD";
    const shipment = await track(tracking_number, courier_code);
    if (shipment.latest_event_time !== null) {
      const date = new Date(shipment.latest_event_time);
      return Moment(date).format(dateFormat);
    }
    return "Latest event time not found";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get weight
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getWeight(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.weight !== null) {
      var weight_unit = await getItem("weight_unit");
      if (weight_unit === "lb") {
        return convertKgToLb(shipment.weight);
      }
      return shipment.weight;
    }
    return "Shipment weight not provided yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get weight provided by the carrier
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getWeightFromCourier(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.weight_courier_kg !== null || shipment.weight_courier_lb !== null) {
      var weight_unit = await getItem("weight_unit");
      if (weight_unit === "lb" && shipment.weight_courier_lb) return shipment.weight_courier_lb;
      if (weight_unit === "lb" && shipment.weight_courier_kg) return convertKgToLb(shipment.weight_courier_kg);
      if (weight_unit === "kg" && shipment.weight_courier_kg) return shipment.weight_courier_kg;
      if (weight_unit === "kg" && shipment.weight_courier_lb) return convertLbToKg(shipment.weight_courier_kg);
    }
    return "Weight from courier not provided";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get customer
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getCustomer(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.customer) return shipment.customer.customer_name;
    return "No customer assigned yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get shipped by
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getShippedBy(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.shippedBy) return shipment.shippedBy.hub_name;
    return "No hub assigned yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get shipped to
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getShippedTo(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.shippedTo) return shipment.shippedTo.hub_name;
    return "No hub assigned yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

/**
 * Get product
 * @customfunction
 * @param {string} tracking_number
 * @param {string} courier_code
 * @return {string}
 * @helpurl https://globalpackagetracker.com/pages/contact
 */
export async function getProduct(tracking_number, courier_code) {
  try {
    const shipment = await track(tracking_number, courier_code);
    if (shipment.product) return shipment.product.product_name;
    return "No product assigned yet";
  } catch (error) {
    console.log(error);
    return error.toString();
  }
}

// helper functions
function convertKgToLb(weight) {
  return (weight * 2.205).toFixed(2);
}
function convertLbToKg(weight) {
  return (weight / 2.205).toFixed(2);
}

async function getItem(key) {
  try {
    const value = await OfficeRuntime.storage.getItem(key);
    return value;
  } catch (error) {
    console.log("Error retrieving data", error);
    return false;
  }
}

CustomFunctions.associate("GETSTATUS", getStatus);
CustomFunctions.associate("GETCOMPLETESTATUS", getCompleteStatus);
CustomFunctions.associate("GETCURRENTLOCATION", getCurrentLocation);
CustomFunctions.associate("GETTRAVELEDLOCATIONS", getTraveledLocations);
CustomFunctions.associate("GETSHIPPINGDATE", getShippingDate);
CustomFunctions.associate("GETCREATIONDATE", getCreationDate);
CustomFunctions.associate("GETREGISTRATIONDATE", getRegistrationDate);
CustomFunctions.associate("GETDELIVERYDATE", getDeliveryDate);
CustomFunctions.associate("GETORIGIN", getOrigin);
CustomFunctions.associate("GETDESTINATION", getDestination);
CustomFunctions.associate("GETTRANSITTIME", getTransitTime);
CustomFunctions.associate("GETCOSTS", getCosts);
CustomFunctions.associate("GETSERVICETYPE", getServiceType);
CustomFunctions.associate("GETLATESTEVENT", getLatestEvent);
CustomFunctions.associate("GETLATESTEVENTDATE", getLatestEventDate);
CustomFunctions.associate("GETWEIGHT", getWeight);
CustomFunctions.associate("GETWEIGHTFROMCOURIER", getWeightFromCourier);
CustomFunctions.associate("GETCUSTOMER", getCustomer);
CustomFunctions.associate("GETSHIPPEDBY", getShippedBy);
CustomFunctions.associate("GETSHIPPEDTO", getShippedTo);
CustomFunctions.associate("GETPRODUCT", getProduct);